module.exports = __webpack_public_path__ + "img/store.2f13c7ac.svg";